var map = {
	"./AE.png": 1818,
	"./AF.png": 7618,
	"./AG.png": 8887,
	"./AL.png": 5294,
	"./AR.png": 4777,
	"./AT.png": 8566,
	"./AU.png": 8333,
	"./AZ.png": 1017,
	"./BA.png": 3530,
	"./BD.png": 5309,
	"./BE.png": 4658,
	"./BG.png": 2374,
	"./BH.png": 5913,
	"./BI.png": 2137,
	"./BN.png": 4740,
	"./BR.png": 7446,
	"./BY.png": 9051,
	"./CA.png": 404,
	"./CH.png": 6511,
	"./CI.png": 4577,
	"./CL.png": 3504,
	"./CN.png": 3066,
	"./CO.png": 2969,
	"./CR.png": 8225,
	"./CZ.png": 2007,
	"./DE.png": 6172,
	"./DK.png": 8207,
	"./DO.png": 6116,
	"./DZ.png": 2636,
	"./EC.png": 5918,
	"./EG.png": 1478,
	"./ES.png": 9144,
	"./ET.png": 5998,
	"./FI.png": 8473,
	"./FR.png": 41,
	"./GA.png": 9187,
	"./GB.png": 5962,
	"./GD.png": 6103,
	"./GE.png": 5967,
	"./GH.png": 2029,
	"./GR.png": 7421,
	"./GY.png": 2617,
	"./HK.png": 7204,
	"./HR.png": 2252,
	"./HU.png": 6860,
	"./ID.png": 1097,
	"./IE.png": 525,
	"./IL.png": 9924,
	"./IN.png": 6399,
	"./IQ.png": 8758,
	"./IR.png": 8808,
	"./IT.png": 5970,
	"./JM.png": 2739,
	"./JO.png": 1539,
	"./JP.png": 8193,
	"./KE.png": 2782,
	"./KG.png": 11,
	"./KH.png": 8858,
	"./KR.png": 3962,
	"./KW.png": 4782,
	"./LB.png": 7391,
	"./LK.png": 1295,
	"./LT.png": 4700,
	"./LY.png": 3521,
	"./MA.png": 3312,
	"./MD.png": 9105,
	"./MK.png": 7056,
	"./MM.png": 2182,
	"./MN.png": 4603,
	"./MO.png": 7683,
	"./MU.png": 5526,
	"./MV.png": 5804,
	"./MX.png": 224,
	"./MY.png": 7675,
	"./MZ.png": 8688,
	"./NA.png": 630,
	"./NG.png": 9446,
	"./NL.png": 2389,
	"./NO.png": 8369,
	"./NP.png": 5924,
	"./NZ.png": 7357,
	"./OM.png": 9087,
	"./PH.png": 7802,
	"./PK.png": 6965,
	"./PL.png": 1156,
	"./PS.png": 674,
	"./PT.png": 6871,
	"./PW.png": 1580,
	"./QA.png": 6945,
	"./RO.png": 4974,
	"./RS.png": 4587,
	"./RU.png": 4850,
	"./RW.png": 662,
	"./SA.png": 2694,
	"./SE.png": 456,
	"./SG.png": 8642,
	"./SK.png": 2794,
	"./SN.png": 1762,
	"./SO.png": 5031,
	"./SX.png": 5347,
	"./SY.png": 2426,
	"./TH.png": 9529,
	"./TN.png": 5288,
	"./TR.png": 3208,
	"./TT.png": 7164,
	"./UA.png": 2077,
	"./UG.png": 5234,
	"./US.png": 7722,
	"./UY.png": 6224,
	"./UZ.png": 8289,
	"./VG.png": 8027,
	"./VN.png": 8911,
	"./ZA.png": 3815,
	"./ZW.png": 4744,
	"./ball_bg1.png": 3848,
	"./default.png": 2875,
	"./default1.png": 8498
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4931;